import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ className, disabled, onChangeCheck, value, item, checked }) => (
  <input
    className={className}
    type="checkbox"
    disabled={disabled}
    onChange={(e) => (item ? onChangeCheck(e, item) : onChangeCheck(e))}
    checked={checked}
    value={value}
  />
);

Checkbox.propTypes = {
  className: PropTypes.string,
  item: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChangeCheck: PropTypes.func,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
};

export default Checkbox;
